export default {
    props: {
        // Form values
        value: {
            type: Object,
            required: true,
        },
        settings: {
            type: [Array, Object],
            required: false,
        },
        errors: {
            required: true,
        },
    },
};
